import React from 'react';
import Footer from './Footer';
import Nav from './Nav';
import 'normalize.css';
import GlobalStyles from '../styles/GlobalStyles';
import Typography from '../styles/Typography';
import favicon from '../assets/images/ceramoni-favicon.ico';
import Helmet from 'react-helmet';

export default function Layout({ children }) {
  return (
    <div>
      <Helmet>
        <link rel="icon" href={favicon} />
      </Helmet>
      <GlobalStyles />
      <Typography />
      <Nav />
      {children}
      <Footer />
    </div>
  );
}
